export default __webpack_public_path__ + "assets/767760e559b6813280f70a14663b7623.svg";